<h1 mat-dialog-title>{{ data.headerText | translate }}</h1>

<mat-dialog-content>
  <div class="confirm-dialog-content">{{ (data.contentText !== null ? data.contentText : '') | translate }}</div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button type="button" mat-button [mat-dialog-close]="'cancel'">
    <span>{{ 'UI.Cancel' | translate | uppercase }}</span>
  </button>
  <div class="cf-flex-auto"></div>
  <button type="button" mat-button [mat-dialog-close]="'discard'">
    <span>{{ 'UI.Discard' | translate | uppercase }}</span>
  </button>
  <button type="submit" mat-raised-button class="primary-button" [mat-dialog-close]="'save'" [disabled]="!data.saveButtonActive">
    <span>{{ 'UI.Save' | translate | uppercase }}</span>
  </button>
</mat-dialog-actions>
